import { render, staticRenderFns } from "./JustificativaDeReprovacaoCartao.vue?vue&type=template&id=481c7868&scoped=true"
import script from "./JustificativaDeReprovacaoCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./JustificativaDeReprovacaoCartao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c7868",
  null
  
)

export default component.exports